import React, { useState, useEffect, useRef, memo } from "react";
import { ButtonBase, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AppsIcon from "@mui/icons-material/Apps";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import useSort from "../useSort";
import TooltipPrimary from "../../tooltips/TooltipPrimary";

const TablePrimary = (props) => {
  const { headers, data, onSave, tableId, onClickActions, disableDrag, disableSave, disableActions } = props;

  const initialRenderSearchRef = useRef(true);
  // eslint-disable-next-line no-unused-vars
  const tableRef = useRef(data);
  const [displayTable, setdisplayTable] = useState(tableRef.current);
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(25);
  const [search, setsearch] = useState("");
  const { items, sortConfig, requestSort } = useSort(tableRef.current);

  useEffect(() => {
    setdisplayTable(items);
  }, [items]);

  useEffect(() => {
    tableRef.current = data;
    setdisplayTable(data);
  }, [data]);

  useEffect(() => {
    if (initialRenderSearchRef.current) {
      initialRenderSearchRef.current = false;
    } else {
      if (search === "") {
        setdisplayTable(tableRef.current);
      } else {
        searchTable();
      }
    }
  }, [search]);

  function searchTable() {
    // setRowsPerPage(data.rows.length);
    // setPage(0);
    if (search === "") {
    } else {
      const searchData = data.filter((item) => searchResult(item));
      setdisplayTable(searchData);
    }
  }

  function searchResult(row) {
    let res = false;

    for (let i = 0; i < headers.length; i++) {
      if (headers[i].searchable) {
        res = String(row[headers[i].ref]).toLowerCase().includes(search.toLowerCase());
        if (res) {
          break;
        }
      }
    }

    return res;
  }

  function onDragEnd(res) {
    if (!res.destination) return;

    let newTable = JSON.parse(JSON.stringify(displayTable));
    let [selectedRow] = newTable.splice(res.source.index, 1);
    newTable.splice(res.destination.index, 0, selectedRow);
    tableRef.current = newTable;
    setdisplayTable(newTable);
  }

  function renderTableRow() {
    if (displayTable.length === 0) {
      return (
        <tr className="no-data">
          <td>No results found.</td>
        </tr>
      );
    }
    return displayTable.map((item, i) =>
      item ? (
        <Draggable draggableId={item.id} index={i} key={item.id}>
          {(provided) => (
            <tr ref={provided.innerRef} {...provided.draggableProps}>
              {!search && !disableDrag && (
                <td className="sm-col">
                  <ButtonBase className="table-icon" {...provided.dragHandleProps}>
                    <AppsIcon />
                  </ButtonBase>
                </td>
              )}

              {headers.map((header) => {
                return header.component ? (
                  <td key={header.ref}>{header.component(item)}</td>
                ) : (
                  <td
                    key={header.ref}
                    className={`${
                      search !== "" && String(item[header.ref]).toLowerCase().includes(search.toLowerCase())
                        ? "text-highlight"
                        : ""
                    }`}
                  >
                    {item[header.ref]}
                  </td>
                );
              })}

              {!disableActions && (
                <td className="action-col">
                  <TooltipPrimary text="Edit" align="top">
                    <ButtonBase
                      className="table-icon edit"
                      onClick={() => {
                        onClickActions(item, "edit");
                      }}
                    >
                      <EditRoundedIcon />
                    </ButtonBase>
                  </TooltipPrimary>
                  {item.visible ? (
                    <TooltipPrimary text="Disable" align="top">
                      <ButtonBase
                        className="table-icon disable"
                        onClick={() => {
                          onClickActions(item, "disable");
                        }}
                      >
                        <DoNotDisturbAltIcon />
                      </ButtonBase>
                    </TooltipPrimary>
                  ) : (
                    <TooltipPrimary text="Enable" align="top">
                      <ButtonBase
                        className="table-icon enable"
                        onClick={() => {
                          onClickActions(item, "enable");
                        }}
                      >
                        <RemoveRedEyeRoundedIcon />
                      </ButtonBase>
                    </TooltipPrimary>
                  )}
                  <TooltipPrimary text="Delete" align="top">
                    <ButtonBase
                      className="table-icon delete"
                      onClick={() => {
                        onClickActions(item, "delete");
                      }}
                    >
                      <DeleteIcon />
                    </ButtonBase>
                  </TooltipPrimary>
                </td>
              )}
            </tr>
          )}
        </Draggable>
      ) : null
    );
  }

  return (
    <div className="table-primary" id={tableId}>
      <div className="header">
        <div className="search">
          <SearchIcon fontSize="small" />
          <input type="text" placeholder="Search" value={search} onChange={(e) => setsearch(e.target.value)} />
        </div>
        <div className="right">
          {!disableSave && (
            <ButtonBase className="btn" onClick={() => onSave(tableRef.current)}>
              Save
            </ButtonBase>
          )}
        </div>
      </div>
      <div className="scroll-x">
        <table>
          <thead>
            <tr>
              {!search && !disableDrag && (
                <th className="sm-col">
                  <p>Drag</p>
                </th>
              )}
              {headers.map((item, index) => (
                <th key={item.ref}>
                  <p>{item.name}</p>
                  {item.sortable &&
                    (sortConfig && sortConfig.ref === item.ref ? (
                      <ButtonBase className="sort active-sort" onClick={() => requestSort(item.ref)}>
                        {sortConfig.sortType === "ascending" ? <ExpandMoreRoundedIcon /> : <ExpandLessRoundedIcon />}
                      </ButtonBase>
                    ) : (
                      <ButtonBase
                        className="sort"
                        onClick={() => {
                          requestSort(item.ref);
                        }}
                      >
                        <ExpandMoreRoundedIcon />
                      </ButtonBase>
                    ))}
                </th>
              ))}
              {!disableActions && (
                <th>
                  <p>Actions</p>
                </th>
              )}
            </tr>
          </thead>
          <DragDropContext onDragEnd={(res) => onDragEnd(res)}>
            <Droppable droppableId="tableMenu">
              {(provided) => (
                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                  {renderTableRow()}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </div>
    </div>
  );
};

export default memo(TablePrimary);
